module.exports = __webpack_public_path__ + "img/page-active-title.d76e04f4.png";